module.exports = {
  accordion: {
    moreEntries: 'Alle Blog-Einträge zeigen',
  },
  refresh: {
    jobs: {
      all: 'Neu laden',
    },
  },
  submit: {
    contact: {
      all: 'Senden',
    },
    all: {
      all: 'Speichern',
      registerPostAuth: 'Anmeldung(en) speichern',
    },
  },
  showInsert: {
    jobs: {
      all: 'Neuen Job hinzufügen',
    },
  },
  showEdit: {
    members: {
      all: 'Mitgliedsdaten bearbeiten',
    },
  },
  delete: {
    jobs: {
      all: 'Diesen Job löschen',
    },
  },
  lazyload: {
    jobs: {
      all: 'Weitere Jobs laden',
    },
  },
  no: {
    confirm: {
      all: 'Abbrechen',
    },
  },
}